import styled from 'styled-components';

import { breakpoints } from '_constants/mediaOptions';

const Home = styled.div`
    padding-top: 70px;
    padding-bottom: 70px;
    min-height: 70vh;

    ${breakpoints.sm} {
        padding-top: 24px;
        padding-bottom: 0;
    }

    .cards {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        ${breakpoints.md} {
            flex-direction: column;
        }
    }

    .card {
        font-size: 21px;

        ${breakpoints.md} {
            margin-bottom: 24px;
        }

        .title {
            ${breakpoints.sm} {
                font-size: 18px;
            }
        }
    }

    .card-skeleton,
    .info-card,
    .connect-wallet-card,
    .no-allocation-card {
        width: 48%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        ${breakpoints.md} {
            width: 100%;
        }

        & > {
            width: 100%;
            height: 100%;
        }
    }
`;

export default Home;
